// PagePlanner Component

import React from 'react'
import ScrollMagic from 'scrollmagic'
import ReactDom from 'react-dom'

import app from '../../../app.jsx'
import PageHeader from '../../layout/page_header/page_header.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageDetail from '../../page/page_detail/page_detail.jsx'
import PlannerPageProvider from '../../../lib/planner_pageprovider.jsx'
import Loader from '../../../common/common/loader/loader.jsx'
import { PlannerIcon } from '../../../common/layout/menu_icons/planner.jsx'

class PagePlanner extends PageDetail {
  constructor (props) {
    super(props, 'planner', 'planner')

    const fromDate = DateUtil.getMondayByDate(new Date())

    this.data = {
      pageState: {
        sort: 'title',
        sortAsc: true,
        filter: {},
        viewMode: 'day' /* day | week | kanban */,
        isUserMode: false,
        filters: [],
        visibleObjects: this._getAllVisibleObjects(),
        visibleHours: ['planned'],
        showToolbarActions: true,
        expandObjectIds: null // Start with null so that we can expand all objects first time
      },
      context: {
        contacts: [],
        projects: [],
        activities: [],
        tasks: [],
        schedules: [],
        timecards: [],
        projectOptions: [],
        skillOptions: []
      },
      histories: [],
      objects: [],
      kanbanInfo: this._getDefaultKanbanInfo(),
      currentEditObject: null,
      fromDate: fromDate,
      toDate: DateUtil.addDaysToDate(fromDate, 14),
      taskFromDate: null,
      taskToDate: null,
      dayItems: [],
      showLoader: true,
      pageNo: 1
    }

    this._timerTaskHourUpdate = null

    this._references = {
      sidebarTask: React.createRef(),
      uploadErrorDialog: React.createRef(),
      loader: React.createRef()
    }
    this._scrollObj = null
  }

  static get propTypes () {
    return {}
  }

  static get defaultProps () {
    return {}
  }

  componentDidMount () {
    this._getData(false)
    this._initEvents()
    this._initLoadOnScroll()
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
    this._destroyLoadOnScroll()
  }

  isSidebarCollapsed () {
    return true
  }

  canShowCollapse () {
    return false
  }

  /* Render functions */
  renderContent () {
    return (
      <>
        {this._renderPlannerContent()}
        {this._renderLoader()}
        {!this.data.showLoader && <div className='plannerbottom' />}
      </>
    )
  }

  _renderLoader () {
    return (
      <Loader ref={this._references.loader} hidden={!this.data.showLoader} />
    )
  }

  renderRightSidebar () {
    return this._renderRightSidebarPlanner()
  }

  /* Data functions */
  _getData (_bReload) {
    const { taskFromDate, taskToDate } = this.data
    const { fromDate, toDate } = this._calculateFromAndToDates()

    this.data.fromDate = fromDate
    this.data.toDate = toDate

    this._calculateDayItems()

    const params = {
      query: {
        pageIdent: this._pageIdent,
        taskFromDate: taskFromDate,
        taskToDate: taskToDate,
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset()
      }
    }

    return app
      .service('/api/page/planner')
      .find(params)
      .then(plannerRes => {
        this._onPageDataRecieved(plannerRes.pageData)
        this.data.context = plannerRes || null
        this.data.histories = plannerRes.histories || []
        this.data.pageState = plannerRes.pageState

        this._calculateResult(plannerRes)

        // If expandObjectIds is null - then it is first time or filter is changed
        // Then expand all objects initially
        if (
          this.data.pageState.expandObjectIds === null ||
          this.data.pageState.expandObjectIds === undefined
        ) {
          const expandObjectIds = []
          /* if (this.data.context.contacts) {
            this.data.context.contacts.forEach((contact) => {
              expandObjectIds.push(contact.id);
            });
          }

          if (this.data.context.projects) {
            this.data.context.projects.forEach((project) => {
              expandObjectIds.push(project.id);

              if (project.phases) {
                project.phases.forEach((phase) => {
                  expandObjectIds.push(phase.id);
                });
              }
            });
          }

          /* if (this.data.context.activities) {
            this.data.context.activities.forEach((activity) => {
              expandObjectIds.push(activity.id);
            });
          }

          if (this.data.context.tasks) {
            this.data.context.tasks.forEach((task) => {
              expandObjectIds.push(task.id);
            });
          } */

          this.data.pageState.expandObjectIds = expandObjectIds
        }

        this._onDataReceived(null)
      })
      .catch(err => {
        this._onDataReceived(err)
      })
  }

  _reloadData () {
    this.data.pageNo = 1
    this._getData(true)
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PagePlanner: _onDataReceived Error', err)
    } else {
      app.debug('PagePlanner: _onDataReceived [done]')
    }

    this.setState({ dataDate: new Date() })
  }

  _getAllVisibleObjects () {
    return ['contact', 'project', 'phase', 'activity', 'task']
  }

  /* Realtime Events */
  _initEvents () {
    this._initTaskEvents()
    this._initActivityEvents()
    this._initProjectEvents()
  }

  _releaseEvents () {
    this._releaseTaskEvents()
    this._releaseActivityEvents()
    this._releaseProjectEvents()
  }

  _eventReloadTask (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PagePlanner - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  _eventReloadActivity (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PagePlanner - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  _eventReloadProject (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PagePlanner - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  /* Header Functions - START */
  renderHeader () {
    return (
      <PageHeader
        title='plannerv2.pageheader.headerTitle'
        subtitle='plannerv2.pageheader.headerSubtitle'
        icon={<PlannerIcon width={20} />}
      />
    )
  }
  /* Header Functions - END */

  /* Loader Functions - START */
  _onPaginate () {
    this.data.pageNo += 1
    this.setState({ dataDate: new Date() })
  }

  _initLoadOnScroll () {
    const controller = new ScrollMagic.Controller()
    this._scrollObj = new ScrollMagic.Scene({
      triggerElement: ReactDom.findDOMNode(this._references.loader.current),
      triggerHook: 'onEnter'
    })
      .addTo(controller)
      .on('enter', () => {
        if (
          this._references.loader.current &&
          !this._references.loader.current.state.active &&
          this.data.objects.length > 0
        ) {
          this._references.loader.current.makeActive()
          window.setTimeout(() => {
            this._loadMoreData()
          }, 1000)
        }
      })
  }

  _loadMoreData () {
    if (this._references.loader.current) {
      this._references.loader.current.makeInActive()
    }

    if (this._scrollObj) {
      this._scrollObj.update()
      this._onPaginate()
    }
  }

  _destroyLoadOnScroll () {
    if (this._scrollObj) {
      this._scrollObj.destroy()
      this._scrollObj = null
    }
  }
  /* Loader Functions - END */
}

export default PlannerPageProvider(PagePlanner)
